/** Phase 6 shared helpers (post CP-10.4 refactor). */
import React from "react";

export function fmt(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export function Stat({ label, value }) {
  return (
    <div>
      <div className="text-xs text-[var(--avcp-ink-soft)]">{label}</div>
      <div className="font-semibold">{value}</div>
    </div>
  );
}
